import React, { useState, useEffect } from "react";
import "./footer.css"
import 'bootstrap/dist/css/bootstrap.css';
import { Link } from "react-router-dom";

const Footer = () => {

  const setScroll = () => {
    window.scrollTo(0, localStorage.getItem('position'));
  }

  return (
    <>

      <footer className="bg-dark">
        <div className='container pb-4'>
          <div className='box w-50'>
            <div className='logo footerCo'>
              {/* <img src='../images/logo-light.png' alt='' /> */}
              <h3>Why Choose Travel Predesh?</h3>
              <p>Planning a trip can be overwhelming, but with Travel Predesh, it doesn’t have to be. Our experienced team offers tailored itineraries to match your unique preferences, ensuring every detail is perfect. We handle all logistics, saving you time and securing the best deals through our industry connections. Your safety is our priority, providing 24/7 support and staying updated on travel advisories. With our extensive local connections, you’ll access hidden gems and unique experiences. Our all-inclusive packages cover everything, promoting responsible, eco-friendly travel. Choose Travel Predesh for a seamless, unforgettable journey. Your adventure awaits!</p>
              {/* <h6>Expertise and Personalized Service</h6>
              <p>Our experienced team offers tailored itineraries to match your unique preferences, ensuring every detail is perfect.</p>
              <h6>Time and Cost Savings</h6>
              <p>We handle all logistics, saving you time and securing the best deals through our industry connections.</p>
              <h6>Safety and Peace of Mind</h6>
              <p>Your safety is our priority. We provide 24/7 support and stay updated on travel advisories.</p>
              <h6>Exclusive Experiences</h6>
              <p>Access hidden gems and unique experiences with our extensive local connections.</p>
              <h6>Comprehensive Packages and Sustainability</h6>
              <p>Our all-inclusive packages cover everything, and we promote responsible, eco-friendly travel.</p> */}
            </div>
          </div>
          <div className="row w-50">
            <div className='box col-md-6'>
              <h3>Important Links</h3>
              <ul>
                <li>
                  <Link
                    to="/"
                    onClick={() => {
                      setScroll()
                    }}
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    onClick={() => {
                      setScroll()
                    }}
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    onClick={() => {
                      setScroll()
                    }}
                  >
                    Contact Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/blog"
                    onClick={() => {
                      setScroll()
                    }}
                  >
                    Blog
                  </Link>
                </li>
                <li>
                  <Link
                    to="/privacyPolicy"
                    onClick={() => {
                      setScroll()
                    }}
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link
                    to="/termsConditions"
                    onClick={() => {
                      setScroll()
                    }}
                  >
                    Terms & Conditions
                  </Link>
                </li>
              </ul>
            </div>
            <div className='box col-md-6'>
              <h3>Contact Us</h3>
              <ul>
                <li>Registered Address - 518F, HBC, Sector 21 D Faridabad Haryana 121001
                About Travel Pradesh - The file attached</li>
                <li>
                  <Link to="/tel:+917838877705">Phone: +91 7838877705</Link>
                </li>
                <li>
                  <Link to="/mailto:care@travelpradesh.com">Email: care@travelpradesh.com
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="follow-us">
          <div className="container justify-content-center">
            <div className="row">
              <div className="col-sm-12">
                <h4>Follow Us on Social Networks</h4>
                <nav>
                  <a target="_blank" href="https://www.facebook.com/profile.php?id=61560476265259&mibextid=JRoKGi" className='Facebook'><i className="fa-brands fa-facebook-f"></i></a>

                  <a target="_blank" href="https://twitter.com/travelpradesh" className='Twitter'><i className='fa-brands fa-twitter'></i></a>

                  <a target="_blank" href="https://linkedin.com/in/travelpradeshofficial" className='Linkedin'><i className='fa-brands fa-linkedin-in'></i></a>

                  <a target="_blank" href="https://www.instagram.com/travelpradeshofficial/" className='Instagram'><i className='fa-brands fa-instagram'></i></a>

                  <a target="_blank" href="https://youtube.com/@travelpradeshofficial?si=z12Idimcz-vaO6_U" className='Youtube'><i className='fa-brands fa-youtube'></i></a>
                </nav>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright">
          <div className="container justify-content-center">
            <div className="row">
              <div className="col-sm-12">
                <p>Copyright © - Booking | All Rights Reserved.</p>
                <p>Design By <a href="https://codewiretech.com/" target={"_blank"}>Codewire Tech</a></p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer
